// extracted by mini-css-extract-plugin
export default {"icon":"VerifyUser_icon__QvIs9","site-name":"VerifyUser_site-name__e4evz","response":"VerifyUser_response__653+y"};